import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  PointElement,
  LinearScale,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Colors } from "chart.js";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Colors);

const LCPettyCash = ({ dateChart, dataPetty }) => {
  var inCount = 0;
  var outCount = 0;

  const labels = dataPetty.map((x) => x.date);

  const data1 = {
    labels: labels,
    datasets: [
      {
        label: "In",
        data: dataPetty.map((x) => {
          var tmp = 0;
          if (x.amount >= 1) {
            tmp = Number(x.amount);
            inCount = inCount + tmp;
          }
          return inCount;
        }),
        fill: false,

        tension: 0.1,
      },
      {
        label: "Out",
        data: dataPetty.map((x) => {
          var tmp = 0;
          if (x.amount <= 0) {
            tmp = Number(x.amount);
            outCount = outCount + Math.abs(tmp);
          }
          return outCount;
        }),
        fill: false,

        tension: 0.1,
      },
    ],
  };

  var options = {
    scales: {
      y: {
        beginAtZero: true,
        display: true,
      },
      x: {
        display: false,
      },
    },
  };

  return (
    <div>
      <Grid>
        <Typography variant="caption">PettyCash {dateChart}</Typography>
        <Box>
          <Line data={data1} options={options} />
        </Box>
      </Grid>
    </div>
  );
};

export default LCPettyCash;
